require('../../modules/es6.date.to-primitive');
var toPrimitive = require('../../modules/_date-to-primitive');
module.exports = function (it, hint) {
  return toPrimitive.call(it, hint);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/fn/date/to-primitive.js
// module id = 1047
// module chunks = 0